import React from 'react'

import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'

const Elipsis = ({text="", length}) => {
  if(text.length <= length){
    return <span>{text}</span>
  }else{
    const partialText = text.slice(0, length)
    return <span>
      {partialText}
      &nbsp;
      <span className="more">
        &hellip;
      </span>
    </span>
  }

}

Elipsis.propTypes = {
  text: React.PropTypes.string,
  length: React.PropTypes.number.isRequired,
}

export default StatelessFuncToPureComponent(Elipsis)



/** WEBPACK FOOTER **
 ** ./app/components/Elipsis.jsx
 **/